import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
//import i18n from '@/libs/i18n'
import '@/libs/flatpickr'
import '@/libs/sweet-alerts'
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'shepherd.js/dist/css/shepherd.css'

// Interceptor para agregar el token a las llamadas al API
import '@/api/interceptors/JwtToken'

//Complements
import './libs/veevalidate'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
